'use strict';

bbw.directive.bbwPageHelpTree = ['$rootScope', function($rootScope) {
    return {
        restrict: 'A',
        scope: {
            config: '=bbwPageHelpTree'
        },
        link: function(scope, element) {
            var config = scope.config;
            if (!angular.isObject(config)) {
                return;
            }
            var toggleElement = element[0].querySelector('[bbw-page-help-tree-toggle]');
            if (!toggleElement) {
                return;
            }
            toggleElement = angular.element(toggleElement);
            var childrenElement = element[0].querySelector('[bbw-page-help-tree-children]');
            if (!childrenElement) {
                return;
            }
            childrenElement = angular.element(childrenElement);
            var update = function() {
                if (scope.config.expanded) {
                    childrenElement.css('display', 'block');
                    toggleElement.removeClass(config.toggleCollapsedClass);
                    toggleElement.addClass(config.toggleExpandedClass);
                } else {
                    childrenElement.css('display', 'none');
                    toggleElement.removeClass(config.toggleExpandedClass);
                    toggleElement.addClass(config.toggleCollapsedClass);
                }
            };
            toggleElement.on('click', function() {
                var cb = function() {
                    scope.config.expanded = !scope.config.expanded;
                    update();
                };
                if ($rootScope.$$phase) {
                    scope.$evalAsync(cb);
                } else {
                    scope.$apply(cb);
                }
            });
            update();
        }
    };
}];
